import React from 'react'
import styled from 'styled-components'
import { Button, Video } from '@giphy/react-giphy-brand'
import useWindowSize from 'shared/hooks/window-size'
import FooterContainer from './footer-container'
import CopyButton from '../buttons/copy-button'
import Social from '../buttons/social'
import { IGif } from '@giphy/js-types'

// to position the content at the bottom.
// could have flex-ended overlay-manager,
// but don't want to over configure
const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    z-index: 1001;
`
const Footer = styled(FooterContainer)`
    flex-shrink: 0;
    position: relative;
`

const ContentWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    width: 100%;
`

const Cancel = styled(Button)`
    background: transparent;
    color: #fff;
    margin-bottom: 10px;
    width: 100%;
`

const Background = styled.div`
    position: absolute;
    right: 0;
    left: 0;
    bottom: 0;
    top: 0;
    background-color: black;
    opacity: 0.9;
`

type Props = {
    videoData: IGif
    onClose?: () => void
}

// TODO fix `label` which is actually for reporting :/
const VideoShareModal = ({ videoData, onClose }: Props) => {
    const { featuredWidth = window.innerWidth } = useWindowSize()
    return (
        <Container>
            <Background onClick={onClose} />
            <ContentWrapper>
                <Video
                    gif={videoData}
                    videoData={videoData}
                    width={featuredWidth}
                    forceMute
                    noCutout
                    noShare
                    autoPlay
                />
            </ContentWrapper>
            <Footer>
                <CopyButton CTA={`Copy Video Link`} url={videoData.url} label={'video share'} />
                <Social
                    types={[`sms`, `facebook`, `twitter`, `pinterest`, `reddit`]}
                    url={videoData.url}
                    gaEvent={{
                        category: `GIF Detail`,
                        label: videoData.id,
                    }}
                />
                <Cancel onClick={onClose}>Cancel</Cancel>
            </Footer>
        </Container>
    )
}

export default VideoShareModal
